import { useEffect, useState } from 'react';
import { FAQResponse } from '../../helpers/utils/types';
import FAQsSectionCreditReporting from './FAQSectionCreditReporting';
import { getFAQs } from '../../auth/_requests';
import { useAuth } from '../../auth/Auth';

const CreditScore: React.FC = () => {
  const { auth } = useAuth();
  const [creditScoreFaqs, setCreditScoreFaqs] = useState<FAQResponse[]>([]);
  useEffect(() => {
    const getCreditScoreFAQs = async () => {
      try {
        const response = await getFAQs(auth?.data?.token, 'creditScore');
        if (response) {
          setCreditScoreFaqs(response);
        } else {
          setCreditScoreFaqs([]);
        }
      } catch (error) {
        console.error('Error fetching referral FAQs:', error);
      }
    };
    getCreditScoreFAQs();
  }, []);
  return (
    <div className='flex flex-col items-start gap-10 w-full'>
      <FAQsSectionCreditReporting faqs={creditScoreFaqs} />
    </div>
  );
};

export default CreditScore;
